import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AlertService} from "./alert.service";
import {GlobalService} from "./global.service";
import {BaseService} from "./base.service";
import {Observable} from "rxjs";
import {AppUrl} from "../constants/app-url";

@Injectable({
  providedIn: 'root'
})
export class CollegeService extends BaseService{

  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.COLLEGES(), data);
  }
  totalCount(): Observable<any> {
    return this.getRequest(AppUrl.COLLEGES_COUNT());
  }
  get(data): Observable<any> {
    return this.getRequest(AppUrl.COLLEGES(), data);
  }
  getStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.COLLEGE_STATUS(id), data);
  }
  detail(uniqueId): Observable<any> {
    return this.getRequest(AppUrl.COLLEGES(uniqueId));
  }
  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.COLLEGES(id), data);
  }

}
